import React, {useEffect, useContext, useState} from 'react';
import L from 'leaflet'
import "leaflet.vectorgrid"
import { useMap } from 'react-leaflet';
import { Context } from '../store/reducer';
import PopupDefaultKeyLimited from "./Spot/menu/popupDefaultKeyLimited";

/**
 * 99_3 インフラ情報（流域下水道） 管渠
 * @param id
 * @param url
 * @param layerName
 * @param color
 * @param opacity
 * @param borderColor
 * @returns {null}
 * @constructor
 */
const VectorGrid = ({id, url, layerName, color, opacity, borderColor}) => {
    const map = useMap()
    const { state, dispatch } = useContext(Context);

    const [showPopup, setShowPopup ]= useState(false);
    const [spot, setSpot ]= useState(false);
    const [lat, setLat] = useState();
    const [lng, setLng] = useState();

    const styleOptions = {
        color: borderColor,// 線
        opacity: state.opacity,
        fill: true,
        fillColor: color,
        fillOpacity: state.opacity
    }
    
    useEffect(() => {
        
        const vectorGrid = L.vectorGrid.protobuf(url, {
            interactive: true,
            vectorTileLayerStyles: {
                [layerName]: function(properties, i){
                    return styleOptions
                }
            },
        })

        vectorGrid.on('click', function(e) {
            setLat(e.latlng.lat)
            setLng(e.latlng.lng)

            setSpot(e.layer.properties)

            setShowPopup(true)
        });
        
        vectorGrid.addTo(map)

        return () => vectorGrid.remove()
    }, [state.opacity])
    
    return (showPopup ? <PopupDefaultKeyLimited
      id={id}
      latitude={lat}
      longitude={lng}
      spot={
          { ...spot,
              ...{
                  "呼び径" : (spot["呼び径"] && spot["呼び径"] !== '') ? spot["呼び径"]+"（mm）" : "",
                  "管渠延長" : (spot["管渠延長"] && spot["管渠延長"] !== '') ? spot["管渠延長"]+"（m）" : "",
                  "勾配1" : (spot["勾配1"] && spot["勾配1"] !== '') ? spot["勾配1"]+"（‰）" : "",
                  "上流側管底高" : (spot["上流側管底高"] && spot["上流側管底高"] !== '') ? spot["上流側管底高"]+"（TP.m）" : "",
                  "下流側管底高" : (spot["下流側管底高"] && spot["下流側管底高"] !== '') ? spot["下流側管底高"]+"（TP.m）" : "",
                  "上流側土被り" : (spot["上流側土被り"] && spot["上流側土被り"] !== '') ? spot["上流側土被り"]+"（m）" : "",
                  "下流側土被り" : (spot["下流側土被り"] && spot["下流側土被り"] !== '') ? spot["下流側土被り"]+"（m）" : "",
              }
          }
      }
      autoOpen={true}
      keyList={[
        "GISの管理番号",
        "管渠番号",
        "施工法",
        "上流側人孔番号",
        "下流側人孔番号",
        "管材質",
        "管種別",
        "断面形状",
        "呼び径",
        "管渠延長",
        "勾配1",
        "上流側管底高",
        "下流側管底高",
        "上流側土被り",
        "下流側土被り",
        "設置場所住所"
      ]}
    option={{
          id: id
      }}
    /> : null)
}

export default VectorGrid
